export const ErrorText = {
  PASSWORD_NOT_MATCH: '비밀번호가 일치하지 않습니다.',
  CONTACT: '이미 가입된 연락처입니다.',
  EMAIL: '이미 가입된 이메일입니다.',
  EMAIL_ALREADY_CONNECTED: '이미 연동된 이메일 계정이 있습니다.',
} as const;
